module.exports = __webpack_public_path__ + "static/media/pricesIco_Selected.0224bc20.svg";